if (!customElements.get('jw-bundle-builder')) {
  customElements.define('jw-bundle-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const on = (node, event, fn) => node?.addEventListener(event, fn, { signal: this.abort.signal });
      this.items = [...this.querySelectorAll('[data-bundle-item]:not([disabled])')];
      this.allItems = [...this.querySelectorAll('[data-bundle-item]')];
      this.progress = this.querySelector('[data-bundle-progress]');
      this.dots = this.querySelector('[data-bundle-dots]');
      this.addButton = this.querySelector('[data-bundle-add]');
      this.entryThree = this.querySelector('[data-bundle-entry-three]');
      this.banner = this.querySelector('[data-bundle-banner]');
      this.checkoutThree = this.querySelector('[data-bundle-checkout-three]');
      this.continueButton = this.querySelector('[data-bundle-continue]');
      this.feedback = this.querySelector('[data-bundle-feedback]');
      this.filters = [...this.querySelectorAll('[data-bundle-filter]')];
      this.filterEmpty = this.querySelector('[data-bundle-filter-empty]');
      if (!this.addButton) return;
      if ('IntersectionObserver' in window) {
        this.dataset.progressVisible = 'false';
        this.visibilityObserver = new IntersectionObserver(entries => {
          this.dataset.progressVisible = String(entries[0].isIntersecting);
        });
        this.visibilityObserver.observe(this);
      }
      this.selected = new Set();
      this.storageKey = 'jw-rotation-v1';
      this.category = '';
      this.bannerDismissed = false;
      this.target = Number(this.dataset.initialTarget || 6);
      this.price = this.dataset.initialPrice || '999';
      this.allItems.forEach(item => {
        const card = item.closest('[data-rotation-card]');
        const selects = [...(card?.querySelectorAll('[data-rotation-variant]') || [])];
        const select = selects[0];
        if (select) {
          try {
            const saved = JSON.parse(localStorage.getItem(this.storageKey));
            const previous = [...select.options].find(option => saved?.variants?.includes(option.value) && !option.disabled);
            if (previous) select.value = previous.value;
          } catch {}
          item.dataset.variantId = select.value;
          card.querySelectorAll('[data-rotation-price]').forEach(price => { price.textContent = select.selectedOptions[0]?.dataset.price || price.textContent; });
          selects.forEach(control => { control.value = select.value; on(control, 'change', () => {
            if (this.busy) return;
            const wasSelected = this.selected.delete(item.dataset.variantId);
            item.dataset.variantId = control.value;
            selects.forEach(other => { other.value = control.value; });
            card.querySelectorAll('[data-rotation-price]').forEach(price => { price.textContent = control.selectedOptions[0]?.dataset.price || price.textContent; });
            if (wasSelected) this.selected.add(control.value);
            this.render();
          }); });
        }
        const dialog = card?.querySelector('dialog');
        const trigger = card?.querySelector('[data-rotation-view]');
        on(trigger, 'click', () => {
          dialog?.showModal();
          this.emit('rotation_product_view', { product_id: item.dataset.productId });
        });
        on(dialog?.querySelector('[data-rotation-close]'), 'click', () => dialog.close());
        on(dialog?.querySelector('[data-rotation-quick-add]'), 'click', () => {
          if (!this.selected.has(item.dataset.variantId)) item.click();
          dialog.close();
        });
        on(dialog, 'click', event => { if (event.target === dialog) dialog.close(); });
      });
      try {
        const saved = JSON.parse(localStorage.getItem(this.storageKey));
        if (saved && Array.isArray(saved.variants)) {
          const valid = new Set(this.items.map(item => item.dataset.variantId));
          this.selected = new Set(saved.variants.filter(id => valid.has(id)).slice(0, 6));
          if (saved.target === 3 || saved.target === 6) this.target = saved.target;
          if (this.selected.size > 3) this.target = 6;
          this.price = this.target === 3 ? '699' : '999';
        }
      } catch {}
      const params = new URLSearchParams(location.search);
      const requestedTarget = Number(params.get('target'));
      const prefill = (params.get('variants') || params.get('add') || '').split(',').filter(Boolean).slice(0, 6);
      const requested = [];
      prefill.forEach(id => {
        const card = this.allItems.find(item => {
          const select = item.closest('[data-rotation-card]')?.querySelector('[data-rotation-variant]');
          return item.dataset.variantId === id || [...(select?.options || [])].some(option => option.value === id && !option.disabled);
        });
        if (!card || card.disabled) return;
        const wasSelected = this.selected.delete(card.dataset.variantId);
        const selects = card.closest('[data-rotation-card]')?.querySelectorAll('[data-rotation-variant]') || [];
        selects.forEach(select => { select.value = id; });
        card.dataset.variantId = id;
        if (wasSelected) this.selected.add(id);
        if (!requested.includes(id)) requested.push(id);
      });
      if (params.has('variants') && requested.length === 6) this.selected = new Set(requested);
      else requested.forEach(id => { if (this.selected.size < 6) this.selected.add(id); });
      if (requestedTarget === 3 || requestedTarget === 6) this.target = requestedTarget;
      if (this.selected.size > 3) this.target = 6;
      this.price = this.target === 3 ? '699' : '999';
      on(this.entryThree, 'click', () => this.setTarget(3));
      on(this.checkoutThree, 'click', () => { this.setTarget(3); this.addBundle(); });
      on(this.continueButton, 'click', () => { this.emit('rotation_upgrade_clicked'); this.bannerDismissed = true; this.setTarget(6); this.bannerDismissed = true; this.render(); });
      on(this.addButton, 'click', () => this.addBundle());
      this.items.forEach(item => on(item, 'click', () => this.toggleItem(item)));
      this.filters.forEach(button => on(button, 'click', () => this.setFilter(button)));
      on(document, 'click', event => {
        const trigger = event.target.closest('[data-rotation-target]');
        if (!trigger) return;
        this.setTarget(Number(trigger.dataset.rotationTarget));
      });
      this.render();
      this.emit('rotation_page_view');
    }
    disconnectedCallback() {
      this.visibilityObserver?.disconnect();
      this.abort?.abort(); this.abort = null;
    }
    setTarget(target) {
      if (![3, 6].includes(target)) return;
      if (target === 3 && this.selected.size > 3) {
        this.feedback.textContent = this.dataset.reduceSelection;
        return;
      }
      this.target = target;
      this.price = target === 3 ? '699' : '999';
      this.bannerDismissed = false;
      this.render();
    }
    setFilter(button) {
      this.category = button.dataset.bundleFilter;
      this.filters.forEach(f => f.classList.toggle('is-active', f === button));
      let visible = 0;
      this.allItems.forEach(item => {
        const match = !this.category || item.dataset.category === this.category;
        (item.closest('[data-rotation-card]') || item).hidden = !match;
        if (match) visible += 1;
      });
      if (this.filterEmpty) this.filterEmpty.hidden = visible > 0;
    }
    toggleItem(item) {
      if (this.busy) return;
      const id = item.dataset.variantId;
      if (this.selected.has(id)) {
        this.selected.delete(id);
        this.emit('rotation_product_remove', { variant_id: id });
        item.classList.remove('is-selected'); item.setAttribute('aria-pressed', 'false'); this.setMark(item, false);
      } else {
        if (this.selected.size === 6) {
          this.feedback.textContent = this.dataset.limitMessage;
          return;
        }
        this.selected.add(id);
        if (this.selected.size > 3) this.target = 6;
        this.price = this.target === 3 ? '699' : '999';
        this.emit('rotation_product_add', { variant_id: id });
        if ([3, 6].includes(this.selected.size)) this.emit(`rotation_progress_${this.selected.size}`);
        item.classList.add('is-selected'); item.setAttribute('aria-pressed', 'true'); this.setMark(item, true);
      }
      if (this.feedback) this.feedback.textContent = '';
      this.render();
    }
    emit(name, data = {}) {
      try {
        const published = window.Shopify?.analytics?.publish?.(name, { ...data, selected: this.selected.size, target: this.target });
        published?.catch?.(() => {});
      } catch {}
    }
    setMark(item, selected) {
      const mark = item.querySelector('[data-item-mark]');
      if (mark) mark.textContent = selected ? this.dataset.markAdded : this.dataset.markAdd;
    }
    fill(template) {
      return template.replaceAll('__SELECTED__', this.selected.size).replaceAll('__TARGET__', this.target).replaceAll('__PRICE__', this.price);
    }
    renderDots() {
      if (!this.dots) return;
      const count = this.selected.size;
      const filled = Math.min(count, this.target);
      let html = '';
      for (let i = 0; i < this.target; i += 1) html += `<span class="jw-dot${i < filled ? ' is-filled' : ''}"></span>`;
      if (count > this.target) html += `<span class="jw-dot-extra">+${count - this.target}</span>`;
      this.dots.innerHTML = html;
    }
    render() {
      const count = this.selected.size;
      const tier = this.querySelector('[data-bundle-tier]');
      if (tier) tier.textContent = `${this.target} for ₹${this.price}`;
      this.items.forEach(item => {
        const selected = this.selected.has(item.dataset.variantId);
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', String(selected));
        this.setMark(item, selected);
      });
      try { localStorage.setItem(this.storageKey, JSON.stringify({ target: this.target, variants: [...this.selected] })); } catch {}
      if (this.entryThree) this.entryThree.hidden = count > 0 || this.target === 3;
      this.renderDots();

      let message;
      if (this.target === 6) {
        message = count <= 6 ? this.dataset[`milestone-${count}`] : this.dataset.milestoneOver;
      } else if (count === 0) message = this.dataset.threeChoose;
      else if (count < 3) message = this.fill(this.dataset.threeCounting);
      else message = this.dataset.threeReady;
      if (this.progress) this.progress.textContent = `${this.fill(this.dataset.progressCount || '__SELECTED__ / __TARGET__')} · ${message || ''}`;

      const ready = count === this.target;
      this.addButton.disabled = !ready;
      if (this.target === 6) {
        this.addButton.textContent = ready ? this.dataset.ctaReadySix : this.dataset.ctaBuilding;
      } else {
        this.addButton.textContent = ready ? this.dataset.ctaReadyThree : this.dataset.ctaDisabledThree;
      }

      const showBanner = count === 3 && !this.bannerDismissed;
      if (this.banner) this.banner.hidden = !showBanner;
    }
    async addBundle() {
      if (this.addButton.disabled || this.busy) return;
      if (this.dataset.checkoutEnabled !== 'true') {
        if (this.feedback) this.feedback.textContent = this.dataset.checkoutPending;
        return;
      }
      this.busy = true;
      this.addButton.disabled = true;
      if (this.feedback) this.feedback.textContent = '';
      const pendingKey = 'jw-rotation-pending-v1';
      let pending;
      try { pending = JSON.parse(localStorage.getItem(pendingKey)); } catch {}
      let group = pending?.group || crypto.randomUUID();
      let count = pending?.count || this.target;
      const clearPending = () => { try { localStorage.removeItem(pendingKey); } catch {} };
      const items = [...this.selected].map(id => ({ id, quantity: 1, properties: { _jw_rotation: group, _jw_rotation_size: String(this.target) } }));
      try {
        let recoveredCart;
        if (pending) {
          const recovery = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { cache: 'no-store' });
          if (!recovery.ok) throw new Error('cart-recovery-failed');
          recoveredCart = await recovery.json();
          if (!recoveredCart.items.some(line => line.properties?._jw_rotation === group)) {
            clearPending(); pending = null; recoveredCart = null; count = this.target;
          }
        }
        if (!recoveredCart) {
        try { localStorage.setItem(pendingKey, JSON.stringify({ group, count: this.target })); } catch {}
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('cart-add-failed');
        }
        let cart = recoveredCart;
        if (!cart) {
        const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { cache: 'no-store' });
        if (!cartResponse.ok) throw new Error('cart-verification-failed');
        cart = await cartResponse.json();
        }
        const lines = cart.items.filter(line => line.properties?._jw_rotation === group);
        let eligible;
        try { eligible = JSON.parse(this.dataset.eligibleProducts); } catch {}
        const eligibleCount = eligible ? cart.items.filter(line => eligible.includes(line.product_id)).reduce((n, line) => n + line.quantity, 0) : count;
        const expected = count * (eligibleCount >= 6 ? 16650 : 23300);
        const correct = cart.currency === 'INR' && lines.reduce((n, line) => n + line.quantity, 0) === count && lines.reduce((n, line) => n + line.final_line_price, 0) === expected;
        if (!correct) {
          const rollback = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: Object.fromEntries(lines.map(line => [line.key, 0])) })
          });
          if (!rollback.ok) throw new Error('cart-rollback-failed');
          clearPending();
          throw new Error('bundle-price-unavailable');
        }
        clearPending();
        this.emit('rotation_added_to_cart', { variant_ids: [...this.selected], rotation_id: group });
        this.emit('rotation_completed', { variant_ids: [...this.selected], rotation_id: group });
        this.selected.clear();
        try { localStorage.removeItem(this.storageKey); } catch {}
        window.location.href = this.dataset.cartUrl || '/cart';
      } catch (error) {
        if (this.feedback) this.feedback.textContent = this.dataset.cartError;
        this.busy = false;
        this.render();
      }
    }
  });
}
